import { SVGProps } from 'react';

const BookCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 21v.5a.5.5 0 0 1-.5.5H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2M3 20a2 2 0 0 1 2-2h.803M9 15V4a2 2 0 0 1 2-2h9.5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H11a2 2 0 0 1-2-2m0 0a2 2 0 0 1 2-2h10"
    />
  </svg>
);
export default BookCopy;
